import axios from '@/utils/axios';
import  queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        issueVoucher:null,
        issueVouchers: [],
        itemSearchResult: null,
        userRules: null
    },
     mutations: {
        setItemSearchResult(state, payload) {
            state.itemSearchResult = payload;
        },
        setIssueVoucher(state, payload) {
            state.issueVoucher = payload;
        },
        setIssueVouchers(state, payload) {
            state.issueVouchers = payload;
        },
        setUserRules(state, payload) {
            state.userRules = payload;
        }

     },
     actions: {
         search({commit, rootState, dispatch}, payload) {
             let query = queryString(payload);
             return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/issue-vouchers-search?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    commit('setItemSearchResult', response.data);
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
             })
         },
         storeIssueVoucher({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `${rootState.warehouse.routePrefix}/issue-vouchers`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                })
            })
         },
         updateIssueVoucher({rootState, dispatch}, payload) {
            return new Promise((resolve, reject)=> {
                axios.request({
                    method: "put",
                    url: `${rootState.warehouse.routePrefix}/issue-vouchers/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        removeIssueVoucher({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/issue-vouchers/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        removeIssueVouchers({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/issue-vouchers`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchIssueVoucher({commit, rootState, dispatch}, payload) {
            return new Promise((resolve, reject) =>{
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/issue-vouchers/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setIssueVoucher', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchIssueVouchers({commit, rootState, dispatch}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) =>{
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/issue-vouchers?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setIssueVouchers', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchUserRules({commit, rootState, state}) {
            if(!state.userRules) {
                return new Promise((resolve, reject) => { 
                    axios.request({
                        method: 'get',
                        url: `${rootState.warehouse.routePrefix}/issue-vouchers-rules`,
                        headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                    })
                    .then((response) => {
                        commit('setUserRules', response.data);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        // if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                        reject(error);
                    })
                })
            }
        }
     }
}